import { CellShape } from "../wire/cell-shape.ts";
import { SheetsNetwork } from "../wire/rows-network.ts";

/** The cell shapes of the built-in row types (task, event, weather, …). */
export namespace RowShapes {
  export const TASK: CellShape<SheetsNetwork.TaskCell> = CellShape.model<SheetsNetwork.TaskCell>({
    id: "task/v1",
    encoding: "task.v1",
    model: SheetsNetwork.TaskCell.MODEL,
  });

  export const EVENT: CellShape<SheetsNetwork.EventCell> = CellShape.model<SheetsNetwork.EventCell>({
    id: "event/v1",
    encoding: "event.v1",
    model: SheetsNetwork.EventCell.MODEL,
  });

  export const WEATHER: CellShape<SheetsNetwork.WeatherCell> = CellShape.model<SheetsNetwork.WeatherCell>({
    id: "weather/v1",
    encoding: "weather.v1",
    model: SheetsNetwork.WeatherCell.MODEL,
  });

  export const SLOT: CellShape<SheetsNetwork.SlotCell> = CellShape.model<SheetsNetwork.SlotCell>({
    id: "slot/v1",
    encoding: "slot.v1",
    model: SheetsNetwork.SlotCell.MODEL,
  });

  export const TIMEZONE: CellShape<SheetsNetwork.TimezoneCell> = CellShape.model<SheetsNetwork.TimezoneCell>({
    id: "timezone/v1",
    encoding: "timezone.v1",
    model: SheetsNetwork.TimezoneCell.MODEL,
  });

  export const LOGS: CellShape<SheetsNetwork.LogsCell> = CellShape.model<SheetsNetwork.LogsCell>({
    id: "logs/v1",
    encoding: "logs.v1",
    model: SheetsNetwork.LogsCell.MODEL,
  });
}
